export default async function postArchivo(body) {
  const endpoint = localStorage.getItem("apiDocuments");

  const header = {
    "Content-Type": " application/json",
  };

  const url = endpoint + "report";
  const js = JSON.stringify(body);

  try {
    const config = { method: "POST", headers: header, body: js };
    const response = await fetch(url, config);
    const json = await response.json();
    return json;
  } catch (error) {
    console.log("Error" + error);
  }
}
